import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useQueryParams, useToastNotification } from '@/hooks';
import { ChangePasswordForm, MainCard } from '@/components';
import { NavigationSource, PagesPaths } from '@/enums';
import { useMutation } from '@tanstack/react-query';
import { resetPassword } from './passwordReset';
import styles from './ResetPassword.module.scss';

const TOKEN_PARAM_KEY = 'sol';

const ResetPassword: FC = () => {
  const { t } = useTranslation('resetPassword');
  const navigate = useNavigate();

  const { get: getQueryParam } = useQueryParams();
  const token = getQueryParam(TOKEN_PARAM_KEY);

  const { showToast } = useToastNotification();

  const resetPasswordMutation = useMutation({
    mutationFn: resetPassword,
    onSuccess: () => {
      navigate(`${PagesPaths.Login}?from=${NavigationSource.ResetPassword}`);
    },
    onError: () => {
      showToast({ severity: 'error', detail: t('toastErrorText') });
    },
  });

  const handleFormSubmit = (newPassword: string) => {
    if (token) {
      resetPasswordMutation.mutate({ password: newPassword, token });
    }
  };

  const submitButtonText = resetPasswordMutation.isPending
    ? t('loadingButton')
    : t('submitButton');

  return (
    <MainCard>
      <div className={styles.resetPassword}>
        <h1>{t('resetPasswordTitle')}</h1>
        <p>{t('passwordInstructions')}</p>
        <ChangePasswordForm
          onSubmit={handleFormSubmit}
          submitButtonText={submitButtonText}
          isLoading={resetPasswordMutation.isPending}
        />
      </div>
    </MainCard>
  );
};

export default ResetPassword;
